import CityPageTemplate from "../city-template/CityPageTemplate";
import { garyConfig } from "./data";

export default function GaryPage() {
  return <CityPageTemplate config={garyConfig} />;
}